import React from 'react';
import { Loader2 } from 'lucide-react';

const StatusControls = ({ 
  vendorProfile, 
  vendor, 
  onToggleFeatured, 
  onToggleActive,
  isUpdatingFeatured = false,
  isUpdatingActive = false
}) => {
  return (
    <div>
      <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4">Status Controls</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {/* Featured Vendor Toggle */}
        <div className="flex items-center justify-between p-3 sm:p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          <div className="min-w-0 flex-1 mr-4">
            <h4 className="text-sm font-medium text-gray-900">Featured Vendor</h4>
            <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
              Show in featured listings
            </p>
          </div>
          <button
            onClick={onToggleFeatured}
            disabled={isUpdatingFeatured}
            className={`relative inline-flex h-5 w-9 sm:h-6 sm:w-11 items-center rounded-full transition-colors flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed ${
              vendorProfile?.is_featured ? 'bg-primary-600' : 'bg-gray-200'
            }`}
            aria-label={vendorProfile?.is_featured ? 'Remove from featured' : 'Add to featured'}
          >
            {isUpdatingFeatured ? (
              <Loader2 className="w-3 h-3 sm:w-4 sm:h-4 text-white animate-spin mx-auto" />
            ) : (
              <span
                className={`inline-block h-3 w-3 sm:h-4 sm:w-4 transform rounded-full bg-white transition-transform ${
                  vendorProfile?.is_featured ? 'translate-x-5 sm:translate-x-6' : 'translate-x-1'
                }`}
              />
            )}
          </button>
        </div>

        {/* Active Status Toggle */}
        <div className="flex items-center justify-between p-3 sm:p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          <div className="min-w-0 flex-1 mr-4">
            <h4 className="text-sm font-medium text-gray-900">Active Status</h4>
            <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
              Vendor can receive bookings
            </p>
          </div>
          <button
            onClick={onToggleActive}
            disabled={isUpdatingActive}
            className={`relative inline-flex h-5 w-9 sm:h-6 sm:w-11 items-center rounded-full transition-colors flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed ${
              vendor?.is_active ? 'bg-primary-600' : 'bg-gray-200'
            }`}
            aria-label={vendor?.is_active ? 'Deactivate vendor' : 'Activate vendor'}
          >
            {isUpdatingActive ? (
              <Loader2 className="w-3 h-3 sm:w-4 sm:h-4 text-white animate-spin mx-auto" />
            ) : (
              <span
                className={`inline-block h-3 w-3 sm:h-4 sm:w-4 transform rounded-full bg-white transition-transform ${
                  vendor?.is_active ? 'translate-x-5 sm:translate-x-6' : 'translate-x-1'
                }`}
              />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusControls;

